// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3Mwz8","range":"MonthRangeSwitch_range__1uQNO","disabled":"MonthRangeSwitch_disabled__7JI0J"};